<template>
  <div>
    <transition name="fade">
			<div v-if="redpackStatus" class="model-bg"></div>
		</transition>
    <transition name="bounce">
      <div id="redpack-wrapper" class="redpack-wrapper" v-if="redpackStatus" @click.self="close">
        <div class="status-0" v-if="redpackStatus === 1">
          <div class="r-head clearfix">
            <span class="left" @click="mark = 0" :style="{ backgroundColor: mark === 0 ? '#d8383b' : '' }">发红包</span>
            <span class="left" @click="mark = 1" :style="{ backgroundColor: mark === 1 ? '#d8383b' : '' }">兑换金币</span>
            <i @click="close" class="redpack-sprite icon-close right"></i>
          </div>
          <ul class="r-body">
            <li class="line-0 clearfix">
              <p class="left" v-if="mark === 0">您当前的金币数为<span class="color-y">{{ redpackGcoins }}</span>金币，<span class="color-y" @click="mark = 1">立即兑换 </span></p>
              <p class="left" v-else>1G币可兑换100金币，仅支持整数兑换</p>
              <nuxt-link class="kiki right" to="/activity#line-3" target="_blank">红包规则</nuxt-link>
            </li>
            <li class="line-1" v-if="mark === 0">
              <p>
                <label for="redpack-count">红包个数：</label><input v-model.trim="count" type="text" maxlength="2" placeholder="请输入小于20的整数" autofocus>
              </p>
              <p>
                <label for="redpack-money">总金额：</label><input v-model.trim="discount" type="text" placeholder="请输入大于红包个数的整数">
              </p>
              <p>
                <label for="redpack-money">祝福语：</label><input v-model.trim="remark" type="text" maxlength="12" placeholder="限12个字">
              </p>
              <p class="clearfix"><span v-if="redpackGcoins < 1"><b>!</b>您的金币余额不足</span></p>
            </li>
            <li class="line-1 line-1-1" v-else>
              <p>要更换的金币数：</p>
              <p><input v-model.trim="toGcoins" type="text" maxlength="6" placeholder="请输入整数"> <span>00个</span></p>
              <p>需花费{{ _toGcoins }}G币，您的G币余额是{{ authUser.gcoins }}，<nuxt-link to="/pay" class="color-y" target="_blank">立即充值 &raquo;</nuxt-link></p>
            </li>
            <li class="line-2 clearfix activity-button">
              <button class="left" @click="reset">重填</button>
              <button class="right" @click="submit" :disabled="isDisabled">提交</button>
            </li>
          </ul>
        </div>
        <div class="status-1 redpack-sprite" v-else-if="redpackStatus === 2 || redpackStatus === 3 || redpackStatus === 4">
          <i @click.self="close" class="redpack-sprite icon-close"></i>
          <p class="avatar-wrap">
            <img class="avatar" :src="data.userAvatar" alt="头像" />
          </p>
          <p class="user-name">
            <span class="ellipsis">{{ data.userName }}</span>的红包
          </p>
          <p class="content">
            <span>{{ data.title }}</span>
          </p>
          <div class="type-2" v-if="redpackStatus === 2 || redpackStatus === 4">
            <p><button type="button">{{ redpackStatus === 2 ? '该红包已过期' : '手慢了，红包已抢完' }}</button></p>
            <p><span @click="lookDetailData">看看大家的手气 &raquo;</span></p>
          </div>
          <div class="type-3" v-if="redpackStatus === 3">
            <button @click="open" class="redpack-sprite sprite-0"></button>
          </div>
        </div>
        <div class="status-2" v-else-if="redpackStatus === 5">
          <ol class="head-0 redpack-sprite head-bg">
            <li class="line-0 clearfix">
              <p class="left"><img :src="data.userAvatar" alt="头像">{{ data.userName }}的红包</p>
              <i @click.stop="close" class="redpack-sprite icon-close right"></i>
            </li>
            <li class="line-1">{{ data.title || redpackInfo.title }}</li>
            <li class="line-2">
              <p>
                <span class="color-y" v-if="redpackInfo.goldCoins > 0">抢到<b>{{ redpackInfo.goldCoins }}</b>金币</span>
                <nuxt-link class="kiki" to="/activity#my-redpack" target="_blank">我的红包</nuxt-link>
              </p>
            </li>
            <li class="line-3">
              已领取{{ redpackInfo.count - redpackInfo.remainingCount }}个/{{ redpackInfo.count }}个<span v-if="redpackInfo.status === 1">，红包已过期</span><span v-if="redpackInfo.isEmpty === 1">，已抢光</span>
            </li>
          </ol>
          <ul class="body-0">
            <li class="clearfix" v-for="(item, index) of redpackInfo.list" :key="index">
              <p class="left"><img :src="item.avatar" alt="头像"></p>
              <p class="left">
                <span class="name ellipsis">{{ item.userName }}</span>
                <span class="time">{{ item.createdAt }}</span>
              </p>
              <p class="right"><b>{{ item.gcoins }}</b>金币</p>
              <p class="right" v-if="redpackInfo.isEmpty === 1 && !item.isbest"><i class="redpack-sprite icon-top"></i>最佳手气</p>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Dialog from '@/utils/Dialog'

export default {
  props: {
    redpackStatus: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      dafault: () => {}
    },
    redpackInfo: {
      type: Object,
      dafault: () => {}
    },
    messageId: Number
  },
  data() {
    return {
      mark: 0,
      remark: '',
      toGcoins: '',
      isDisabled: false,    // 是否禁用提交按钮
      count: null,          // 红包个数
      discount: null        // 红包金额
    }
  },
  methods: {
    // 重置红包输入框
    reset () {
      this.count = this.discount = this.remark = this.toGcoins = null
    },
    // 检测输入框的值是否符合规则（不能为空、必须为数字、不能小于0）
    checkVal (x, y) {
      let _x, _y
      if (x === null || y === null)
        return 0
      else
        _x = Number(x), _y = Number(y)
        if (isNaN(_x) || isNaN(_y)) {
          return 1
        } else if (_x <= 0 || _y <= 0) {
          return 2
        } else if (_x > 20) {
          return 3
        } else if (_y > this.redpackGcoins) {
          return 4
        } else if (_y <= _x) {
          return 5
        } else if (_y > this.redpackGcoins) {
          return 6
        }
    },
    // 发送红包
    submit (e) {
      if (!this.$isLogin()) {
        Dialog.login()
        return
      }
      if (this.mark) {
        // 兑换金币
        if (this._toGcoins === 0 || this._toGcoins > this.authUser.gcoins) {
          this.$notify({
            type: 'error',
            title: '错误',
            message: '输入值有误'
          })
          return
        }
        let gcoins = this.toGcoins * 100
        e.target.disabled = true
        this.$axios._post('/GoldCoinAccount/Exchange', { gcoins }).then(() => {
          this.$store.commit('user/setGcoins', this.authUser.gcoins - this.toGcoins)
          this.$store.commit('user/setRedpackGcoins', this.redpackGcoins + gcoins)
          this.toGcoins = null
          this.$notify({
            type: 'success',
            title: '兑换成功',
            message: `获得${gcoins}金币`
          })
        }).finally(() => {
          e.target.disabled = false
        })
      } else {
        // 发红包
        // if (this.authUser.gcoins < 1) return
        let msg
        switch (this.checkVal(this.count, this.discount)) {
          case 0:
            msg = '值不能为空'
            break
          case 1:
            msg = '值必须为数字'
            break
          case 2:
            msg = '值不能小于或等于零'
            break
          case 3:
            msg = '红包个数不能大于20'
            break
          case 4:
            msg = '总金额不能大于您的金币数'
            break
          case 5:
            msg = '总金额必须大于红包个数'
            break
          case 6:
            msg = '总金额不能大于您的金币数'
            break
          default:
            e.target.disabled = true
            this.$axios._post('/RedPacket/Deliver', {
              roomId: this.$route.params.id,
              topicId: this.roomData.lastTopicId,
              count: this.count,
              gcoins: this.discount,
              title: this.remark
            }).then(res => {
              if (!this.$store.state.room.isWebsocket) {
                this.$store.commit('room/addComment', res)
              }
              this.$store.commit('user/setRedpackGcoins', this.redpackGcoins - this.discount)
              this.$notify({
                type: 'success',
                title: '成功',
                message: '发送红包'
              })
              this.close()
            }).finally(() => {
              e.target.disabled = false
            })
        }
        if (msg) {
          this.$notify.error({
            title: '错误',
            message: msg
          })
        }
      }
    },
    // 拆红包
    open (e) {
      if (!this.$isLogin()) {
        Dialog.login()
        return
      }
      e.target.className += ' hako'
      e.target.disabled = true
      setTimeout(() => {
        this.$axios._post('/RedPacket/Receive', {
          id: this.data.id,
          topicMessageId: this.messageId
        }).then(res => {
          console.log(res)
          if (res.status) {
            // 抢完了
            this.$emit('update:redpackStatus', 4)
          } else {
            // 没抢完
            this.$emit('update:redpackInfo', res)
            this.$emit('update:redpackStatus', 5)
          }
        }).finally(() => {
          e.target.disabled = false
        })
        e.target.className = 'redpack-sprite sprite-0'
      }, 600)
    },
    // 关闭红包组件
    close () {
      this.reset()
      this.mark = 0
      this.$emit('update:redpackStatus', 0)
    },
    // 查看大家的手气
    lookDetailData () {
      this.$emit('update:redpackStatus', 5)
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.user.data,
      roomData: state => state.room.data,
      redpackGcoins: state => state.user.redpackGcoins
    }),
    _toGcoins () {
      return /\d+/.test(this.toGcoins) && this.toGcoins > 0 ? this.toGcoins : 0
    }
  }
}
</script>

<style lang="less" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in below version 2.1.8 */ {
  opacity: 0
}
.bounce-enter-active {
  animation: bounce-in .5s;
}
@keyframes bounce-in {
  0% {
    transform: scale(.5);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
// 弹窗背景
.model-bg {
	position: fixed; left: 0; right: 0; top: 0; bottom: 0; z-index: 1000; background-color: rgba(0,0,0,.5);
}
.redpack-wrapper {
  position: fixed; left: 0; top: 15%; right: 0; bottom: 0; z-index: 1001; overflow: auto; margin: 0;
  // 公用css
  img { display: block; }
  .color-y { color: #fffe03; }
  .kiki {
    border-radius: 3px; background: #8a0e0c; padding: 0 12px 0 6px; position: relative; line-height: 18px; font-size: 14px; color: #fff;
    &:after {
      content: " "; display: inline-block; width: 0; height: 0; border-width: 6px; border-style: solid; border-color: transparent transparent transparent #fff; position: absolute;
    }
  }
  // 常规CSS
  .status-0,
  .status-1,
  .status-2 {
    position: absolute; top: 0; left: 50%; z-index: 1001; transform: translateX(-50%); border-radius: 3px; overflow: hidden;
  }
  .status-0 {
    width: 500px; background-color: #d8383b;
    .r-head {
      height: 50px; background-color: #ef4b4b; line-height: 50px;
      span {
        color: #fff; font-size: 16px; width: 120px; text-align: center; cursor: pointer;
      }
      i { margin: 10px 20px 0 0; }
    }
    .r-body {
      padding: 0 40px 30px;
      .line-0 {
        margin-top: 30px; font-size: 16px; color: #fff;
        p > span:last-child {
          &:after { content: '\00bb'; }
          cursor: pointer;
        }
        .kiki { cursor: pointer; margin-top: 3px;
          &:after { right: -3px; top: 3px; }
        }
      }
      .line-1 {
        font-size: 16px; color: #fff; margin-top: 30px;
        input {
          width: 340px; line-height: 40px; height: 40px; text-indent: 20px; border-radius: 20px; border: 0; box-shadow: inset 0 2px 2px 0px rgba(0, 0, 0, .7);
          &:focus {
            outline: 0;
          }
        }
        p:nth-child(2),
        p:nth-child(3) {
          margin-top: 20px; padding-left: 16px;
        }
        p:nth-child(4) {
          margin: 15px 0;
          span {
            float: right; width: 340px; text-align: left; background: #fbfba5; color: #e33a3d; font-size: 12px; line-height: 2; padding-left: 6px; border-radius: 12px;
            b {
              color: #fff; background: #e63a3a; border-radius: 50%; padding: 0 6px; margin-right: 4px;
            }
          }
        }
        &.line-1-1 {
          height: 190px;
          p:nth-child(1) {
            font-size: 18px;
          }
          p:nth-child(2) {
            padding-left: 0;
            span {
              font-size: 20px;
            }
          }
          p:nth-child(3) {
            font-size: 16px; padding-left: 0;
          }
        }
      }
      .line-2 {
        &.activity-button {
          button {
            width: 200px; font-size: 16px; line-height: 40px; border-radius: 20px; cursor: pointer;
          }
          button:first-child {
            background: #999; color: #ad2f23;
          }
          button:last-child {
            color: #af2f22; background: #fc0;
          }
        }
      }
    }
  }
  .status-1 {
    width: 450px; height: 540px; position: relative;
    .icon-close {
      position: absolute; right: 15px; top: 10px;
    }
    .avatar-wrap {
      width: inherit; height: 200px;
      .avatar {
        width: 126px; height: 126px; border-radius: 50%; background-color: #fff; box-shadow: 0px 5px 5px 0px rgba(153, 0, 0, 0.75); position: relative; left: 50%; transform: translate(-50%, 90px); text-align: center; border: 3px solid #fff;
      }
    }
    .user-name {
      text-align: center; font-size: 16px; color: #fff; margin-top: 25px;
      span {
        display: inline-block; max-width: 120px; text-align: left; vertical-align: -0.3em;
      }
    }
    .content {
      width: 400px; margin: 30px auto 0; text-align: center;
      span {
        font-size: 24px; color: #fff;
      }
    }
    .type-2 {
      p {
        text-align: center; margin-top: 40px;
        button {
          width: 280px; font-size: 20px; line-height: 60px; border-radius: 30px; background-color: #770a0f; color: #e4a9a5;
        }
        span {
          font-size: 14px; color: #eee; cursor: pointer;
          &:hover { color: #fff; }
        }
      }
    }
    .type-3 {
      text-align: center; margin-top: 20px;
      span { border-radius: 50%; position: relative; left: 0; }
    }
  }
  .status-2 {
    width: 450px; height: 580px; background-color: #fff;
    .head-0 {
      height: 200px; position: relative;
      .line-0 {
        padding: 15px 15px 0;
        p {
          font-size: 14px; color: #fff;
          img {
            width: 30px; height: 30px; border-radius: 50%; display: inline-block; vertical-align: middle; margin-right: 6px;
          }
        }
      }
      .line-1 {
        font-size: 24px; color: #fff; text-align: center; margin-top: 20px;
      }
      .line-2 {
        text-align: center;
        p {
          display: inline-block;
          span {
            display: inline-block; margin-right: 4px; font-weight: bold;
            b {
              font-size: 56px; vertical-align: -5%;
            }
          }
          .kiki {
            display: inline-block; margin-top: 45px;
            &:after { right: -3px; top: 3px; }
          }
        }
      }
      .line-3 {
        background: #900; padding-left: 15px; font-size: 14px; line-height: 30px; color: #fff; position: absolute; bottom: 0; left: 0; width: 100%;
      }
    }
    .body-0 {
      padding: 0 30px; height: 380px; overflow-y: auto;
      li {
        border-bottom: 1px solid #ddd; padding: 15px 0;
        p:nth-child(1) {
          img {
            width: 40px; height: 40px; border-radius: 50%;
          }
        }
        p:nth-child(2) {
          margin-left: 16px;
          span {
            display: block;
          }
          .name {
            max-width: 140px; color: #333; font-size: 16px;
          }
          .time {
            font-size: 12px; color: #999; line-height: 18px;
          }
        }
        p:nth-child(3) {
          font-size: 14px; color: #333; margin-top: 2px; margin-left: 10px;
          b { color: #c00; font-size: 22px; vertical-align: -3%; }
        }
        p:nth-child(4) {
          color: #ffb400; font-size: 14px; line-height: 40px;
        }
      }
    }
  }
}
// CSS 雪碧图
.redpack-sprite {
  background: url('~assets/activity/redpack-sprite.png'); display: inline-block; width: 450px; height: 970px;
}
.sprite-0 {
  width: 190px; height: 190px; background-position: -65px -780px; cursor: pointer; border-radius: 50%;
}
.icon-close {
  background-position: -36px -780px; width: 29px; height: 29px; cursor: pointer; display: inline-block;
}
.icon-top {
  background-position: 0 -780px; width: 36px; height: 24px; vertical-align: -0.25em; margin-right: 6px;
}
.head-bg {
  background-position: 0 -580px;
}
.hako {
  position: relative;
  left: 0;
  animation-name: openhako;
  animation-duration: .6s;
  animation-timing-function: ease-in;
  animation-iteration-count: infinite;
}
@keyframes openhako {
  0%   { top: 0; }
  18%  { top: -50px; }
  36%  { top: 0; }
  48%  { top: -50px; }
  64%  { top: 0; }
  95% { top: -150px; }
}
</style>
